import { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

/**
 * Custom hook to check if the auto-square time has passed for the selected script.
 * Fetches `autoSquareTime` and `selectedScript` from Redux.
 * @returns {boolean} - Returns true if the time has passed today.
 */
const useIsTimePassed = () => {
  const { selectedScript, autoSquareTime,AutoSquare,displaySettings } = useSelector(
    (state) => state.UserReducer
  );
  const data=useSelector((state)=>state.UserReducer)
  const [currentTime, setCurrentTime] = useState(moment());
  // Update the current time every minute
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 10000); 

    return () => clearInterval(interval);
  }, []);

  return useMemo(() => {
    if (
      !selectedScript?.market ||
      !autoSquareTime[selectedScript.market]?.time || displaySettings?.AutoSquare!=='on'
    ) {
      return false;
    }

    const squareTime = autoSquareTime[selectedScript.market]?.time;

    return currentTime.format("HH:mm") >= moment(squareTime).format("HH:mm");
  }, [autoSquareTime, selectedScript, currentTime]);
};

export default useIsTimePassed;
